import { usePaywallBlockContext } from "../../../Providers/PaywallBlockProvider";
import { isDesktopPreviewMode } from "../../../Providers/helpers";
import { MobileForm } from "./MobileForm";
import { WebForm } from "./WebForm";

export const FormSidebar = () => {
  const { previewMode } = usePaywallBlockContext();
  return isDesktopPreviewMode(previewMode) ? <WebForm /> : <MobileForm />;
};
